export enum SocialType {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Twitter = 'twitter',
};
